import { ConditionReport } from "@skinsoft/types"
import { conditionReportSelectors } from "@skinsoft/selectors"
import { dbCacheDown } from "../dexie/cache-down"
import { STATS_KEYS } from "../dexie/stats-keys"
import { OfflineDataFetcher } from "../offline-data-fetcher"
import { matchesRegex } from "@skinsoft/utils"

export class ConditionReportOfflineDataFetcher extends OfflineDataFetcher<ConditionReport> {

    constructor() {
        super(dbCacheDown.conditionReport, STATS_KEYS.conditionReport)
    }

    protected async queryTextFilter(entity: ConditionReport, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        const isWemi: boolean = "item" in entity && "manifestation" in entity && "expression" in entity && "work" in entity

        let titleMatch: boolean
        let identifierMatch: boolean
        
        // report title match 
        const title: string = conditionReportSelectors.title(entity, locale)
        try {
            titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false
        } catch(err) {
            titleMatch = false
        }

        // report identifier match
        const identifier: string = (conditionReportSelectors.referenceNumber(entity) as any)?.value ?? conditionReportSelectors.referenceNumber(entity)
        try {
            identifierMatch = identifier ? matchesRegex(lowerCaseQueryText, identifier.toLowerCase()) : false
        } catch(err) {
            identifierMatch = false
        }

        return titleMatch || identifierMatch
    }
}